import { atom } from 'recoil';

// 알림 모달1 관리
export const alarmModal1State = atom({
    key: 'alarmModal1State',
    default: false,
});
export const alarmModal1Text = atom<string | null>({
    key: 'alarmModal1Text',
    default: null,
});

// 알림 모달2 관리
export const alarmModal2State = atom({
    key: 'alarmModal2State',
    default: false,
});
export const alarmModal2Text = atom<string | null>({
    key: 'alarmModal2Text',
    default: null,
});

// 알림 모달3 관리
export const alarmModal3State = atom({
    key: 'alarmModal3State',
    default: false,
});
export const delConfirmText = atom<string>({
    key: 'delConfirmText',
    default: '정말 삭제하시겠습니까?',
});
export const modifyConfirmText = atom<string>({
    key: 'modifyConfirmText',
    default: '정말 수정하시겠습니까?',
});

// 로딩 스피너 관리
export const loadingSpinnerState = atom({
    key: 'loadingSpinnerState',
    default: false,
});